// Copyright (c) 2017 Deere & Company

import ClaimSearchResult from '@deere/cps-it.warranty-model-factory/lib/claim-search-result';
import t from 'tcomb';

const SearchResults = t.list(ClaimSearchResult, 'SearchResults');

export const getDefaultState = () => new SearchResults([]);

export default SearchResults;



// WEBPACK FOOTER //
// ./src/claim/claim-search/state/search-results.js